import BlockField from "../BlockField";
import FieldLabel from "../FieldLabel";
import { FieldType } from "../types";

import { cn } from "@/lib/utils";

interface InputVariableFieldProps {
  children: React.ReactNode | React.ReactNode[];
  name?: string | null;
  className?: string;
  fieldType?: FieldType;
  helpTooltip?: string;
}

const InputVariablesField = ({
  children,
  name = "Sources",
  fieldType = FieldType.Default,
  className,
  helpTooltip,
}: InputVariableFieldProps) => {
  if (!name) {
    return (
      <div className="flex max-w-[500px] flex-col gap-y-3 rounded-md border border-gray-200 bg-gray-50 p-3">
        {children}
      </div>
    );
  }

  if (fieldType !== FieldType.Default) {
    return (
      <div className={cn("space-y-2", className)}>
        <FieldLabel name={name} fieldType={fieldType} />
        <div className="flex max-w-[500px] flex-col gap-y-3 rounded-md border border-gray-200 bg-gray-50 p-3">
          {children}
        </div>
      </div>
    );
  }

  return (
    <BlockField name={name} className={className} helpTooltip={helpTooltip}>
      <div className="flex max-w-[500px] flex-col gap-y-3 rounded-md border border-gray-200 bg-gray-50 p-3">
        {children}
      </div>
    </BlockField>
  );
};

export default InputVariablesField;
